/* istanbul ignore file */
import { RECEIVE_RENTAL_CAR_CONTRACT, REQUEST_RENTAL_CAR_CONTRACT, CONTRACT_RENTAL_CAR } from './types'

export function requestRentalCarContract (params) {
    return {
        type: REQUEST_RENTAL_CAR_CONTRACT,
        ...params,
    }
}

export function receiveRentalCarContract (
    rentalCarContract,
    status = {status: 'success', error: null}) {
    return {
        type: RECEIVE_RENTAL_CAR_CONTRACT,
        rentalCarContract,
        status,
        navigate: false,
    }
}

export function confirmRentalCarContract (
    rentalCarContract,
    status = {status: 'success', error: null}) {
    return {
        type: RECEIVE_RENTAL_CAR_CONTRACT,
        rentalCarContract,
        status,
        navigate: true,
    }
}

export function contactRentalCar (params) {
    return {
        type: CONTRACT_RENTAL_CAR,
        ...params,
    }
}
